import { PhoneInput } from "@expert/common-ui";
import { SegmentedControl, Stack } from "@mantine/core";
import type { JSX } from "react";
import { useState } from "react";
import { groupContacts } from "@/shared-utils";
import { useContactsStateStore } from "../../vdnContacts.store";
import { NameInput } from "../NameInput/NameInput";
import { VdnInput } from "../VdnInput/VdnInput";

export type InputType = "phone" | "vdn" | "name";
export function SegmentedTransferInput(): JSX.Element {
    const [inputType, setInputType] = useState<InputType>("phone");
    const [input, setInput] = useState<string>("");
    const { contacts } = useContactsStateStore();

    return (
        <Stack gap="xs">
            <SegmentedControl
                data={[
                    { label: "Phone Number", value: "phone" },
                    { label: "VDN Extension", value: "vdn" },
                    { label: "Name", value: "name" },
                ]}
                size="xs"
                fullWidth
                value={inputType}
                onChange={(val) => {
                    setInputType(val as InputType);
                    setInput("");
                }}
            />
            <Stack>
                {/* TODO: Implement VDNInput, NameInput */}
                {inputType === "phone" && <PhoneInput value={input} onChange={setInput} />}
                {inputType === "vdn" && <VdnInput value={input} onChange={setInput} />}
                {inputType === "name" && (
                    <NameInput value={input} onChange={setInput} contacts={groupContacts(contacts)} />
                )}
            </Stack>
        </Stack>
    );
}
